module.exports = __webpack_public_path__ + "img/electronicSignature.ea8b69c9.png";